import { Injectable } from '@angular/core';
import { Theme, light } from '../../theme';
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'src/app/interface/app-init.model';
@Injectable({
  providedIn: 'root'
})
export class UiService {
  private _menuExpand = true;
  private _active = 'dashboard';
  private _theme: Theme = light;

  languagesOffered: Array<Language> = [
    {
      name: 'English',
      code: 'en',
      active: true,
      icon: 'assets/images/en_2.png',
    },
    {
      name: 'Français',
      code: 'fr',
      active: true,
      icon: 'assets/images/fr_2.png',
    },
  ];

  public get theme() {
    return this._theme;
  }
  public set theme(value) {
    this._theme = value;
  }
  public get active() {
    return this._active;
  }
  public set active(value) {
    this._active = value;
  }
  public get menuExpand() {
    return this._menuExpand;
  }
  public set menuExpand(value) {
    this._menuExpand = value;
  }

  constructor(
    private translate: TranslateService) { }

  public renderTheme() {
    for (const property of Object.keys(this.theme.properties)) {
      document.documentElement.style.setProperty(property, this.theme.properties[property]);
    }
  }

  public getSupportedLanguage(locale: string): string {
    const supported = this.languagesOffered.map(l => l.code.toLowerCase());
    return supported.includes(locale.toLowerCase()) ? locale.toLowerCase() : 'en';
  }

  public setDefaultLanguage(locale: string)  {
    this.translate.use(this.getSupportedLanguage(locale));
  }

  public extractKeyValueExcept(obj: any, excludedKey: string) {
    const { [excludedKey]: _, ...rest } = obj;
    return rest;
  }

  public extractOnlyKeyValue(obj: any, includedKey: string) {
    const { [includedKey]: value } = obj;
    return { [includedKey]: value };
}

}
